<template>
  <div style="height: 100%">
    <v-card style="height: 100%">
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" align="center">
            <h1>NTS by Employee</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <div style="max-width: 40em; max-height: 32em; overflow-y: auto;">
              <v-data-table
                dense
                :headers="grossProfitByEmployeeHeaders"
                :items="ntsByEmployeeData"
                :calculate-widths="true"
                width="5em"
              >
                <template v-slot:item.employeeName="{ item }">
                  {{ item.employeeName }}
                </template>
                <template v-slot:item.individualGrossProfit="{ item }">
                  {{ item.individualGrossProfit | currency }}
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="end">
            <v-btn
              v-if="!showFetchingDataGIF"
              color="primary"
              outlined
              class="ml-2"
              @click="refreshTile"
              style="float: left;"
              >
                <v-icon>refresh</v-icon>
            </v-btn>
            <i
              v-if="showFetchingDataGIF"
              class="mr-2"
            >
              Fetching Data
            </i>
            <v-progress-circular
              v-if="showFetchingDataGIF"
              :size="30"
              :width="7"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <i
              v-if="lastRefreshTime"
              class="ml-10 mr-5"
            >
              Last Update: {{ lastRefreshTime }}
            </i>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getLocalTimeString } from '@/lib/display'
import { isJSONString } from '@/lib/miscellaneous'

export default {
  data () {
    return {
      lastRefreshTime: null,
      showFetchingDataGIF: false,
      ntsByEmployeeData: [],
      grossProfitByEmployeeHeaders: [
        { text: 'Employee', value: 'employeeName', width: '250px' },
        { text: 'NTS', value: 'individualGrossProfit', width: '120px', align: 'right' }
      ]
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'getNTSByEmployee'
    ]),
    refreshTile () {
      this.showFetchingDataGIF = true
      this.getNTSByEmployee().then((data) => {
        if (data && data.length > 0) {
          let dateTimeNow = new Date()
          this.ntsByEmployeeData = data
          localStorage.setItem('dashboard:nts-by-employee', JSON.stringify(data))
          localStorage.setItem('dashboard:nts-by-employee-last-refresh-time', JSON.stringify(dateTimeNow.toUTCString()))
          this.lastRefreshTime = getLocalTimeString(dateTimeNow)
        }
        this.showFetchingDataGIF = false
      })
    }
  },
  created () {
    if (localStorage.getItem('dashboard:nts-by-employee') && isJSONString(localStorage.getItem('dashboard:nts-by-employee'))) {
      this.ntsByEmployeeData = JSON.parse(localStorage.getItem('dashboard:nts-by-employee'))
    }
    if (localStorage.getItem('dashboard:nts-by-employee-last-refresh-time') &&
      isJSONString(localStorage.getItem('dashboard:nts-by-employee-last-refresh-time'))) {
      let lastRefreshTime = new Date(JSON.parse(localStorage.getItem('dashboard:nts-by-employee-last-refresh-time')))
      this.lastRefreshTime = getLocalTimeString(lastRefreshTime)
    }
    this.refreshTile()
  }
}
</script>
